<div class="provider-search-container">
  <div class="title">{{ props?.title }}</div>
  <div class="provider-search">
    <typeahead-dropdown
    [favoriteHeader]="'Provider Search'"
    (focusout)="validateInput()"
    class="search"
    placeholder="Search using NPI Number or Provider Name"
    [options]="providerResults"
    id="provider"
    (change)="searchProviders($event.detail.value)"
    (select)="selectProviders($event.detail.value)"
    [(ngModel)]="selectedProvider"
    [disabled]="favoriteProviders?.length >= maxProviderBookmarkCount"
    name="provider-selection"
    ngDefaultControl
  >
  </typeahead-dropdown>

  <div class="loader-spinner" *ngIf="loading"><div></div><div></div><div></div><div></div></div>
  <div
    class="bookmark-action clear"
    *ngIf="displayClearResults && selectedProvider"
    (click)="clearSearchResult()"
    (keypress)="clearSearchResult()"
    tabindex="0"
  >Clear Results</div>
  </div>
  <div aria-live="polite">
    <span
     class="validation-error"
      *ngIf="lengthErrorMessage"
    >
      {{lengthErrorMessage}}
    </span>
  </div>
  <div class="error-block">
    <span class="error" *ngIf="favoriteProviders?.length >= maxProviderBookmarkCount">{{ props?.maxProviderLengthError }}</span>
    <span class="error" *ngIf="isMaxProviderLengthWarning">Bookmarking this provider will reach the maximum allowable.  No additional provider roles may be selected until you remove a bookmark</span>
    <span class="error" *ngIf="isSubTypeNotFacilityOrPractitioner">Unknown provider types cannot be bookmarked. Please search for a different provider.</span>
    <span class="error" *ngIf="showNoResultsMsg">Provider not found</span>  
  </div>
</div>